import { LinkProps } from "@tanstack/react-router";
import { Menu } from "lucide-react";
import { Brand, Button } from "../../ui";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "../Sheet";

type TNavbarProps = {
  rightContent?: React.ReactNode;
  mobileNavContent?: React.ReactNode;
  sidebarTrigger?: React.ReactNode;
  breadcrumb?: React.ReactNode;
  brandTo?: LinkProps["to"];
};

export const Navbar = ({ rightContent, mobileNavContent, sidebarTrigger, breadcrumb, brandTo }: TNavbarProps) => {
  return (
    <header className="sticky top-0 z-[--z-navbar] flex h-[--navbar-height] items-center gap-2 bg-background/80 px-4 backdrop-blur-sm md:gap-3 md:px-6">
      {/* Brand + mobile sidebar trigger — hidden on desktop where sidebar owns these */}
      <div className="flex items-center gap-2 md:hidden">
        <Brand to={brandTo} />
        {sidebarTrigger}
      </div>
      <div className="flex min-w-0 flex-1 items-center pl-1">
        {breadcrumb}
      </div>
      <div className="flex items-center gap-2">{rightContent}</div>
      <Sheet>
        <SheetTrigger asChild>
          <Button
            variant="outline"
            size="icon"
            className="shrink-0 sm:hidden"
          >
            <Menu className="h-5 w-5" />
            <span className="sr-only">Toggle navigation menu</span>
          </Button>
        </SheetTrigger>
        <SheetContent side="left">
          <SheetTitle className="sr-only">Navigation menu</SheetTitle>
          <nav className="grid gap-6 text-lg font-medium">
            <Brand
              to={brandTo}
              className="justify-start"
            />
            {mobileNavContent}
          </nav>
        </SheetContent>
      </Sheet>
    </header>
  );
};
